/**
 * @mixin
 */
export default {
  data() {
    return {
      newValue: this.value,
      focused: false,
      hovering: false
    }
  },
  computed: {
    /**
     * Find parent Field, max 3 levels deep.
     */
    parentField() {
      let parent = this.$parent
      for (let i = 0; i < 3; i++) {
        if (parent && !parent.$data.isField) {
          parent = parent.$parent
        }
      }
      return parent
    },
    /**
     * Get the type prop from parent if it's a Field.
     */
    statusType() {
      if (!this.parentField) {
        return
      }
      if (!this.parentField.newType) {
        return
      }
      if (typeof this.parentField.newType === 'string') {
        return this.parentField.newType
      } else {
        for (let key in this.parentField.newType) {
          if (this.parentField.newType[key]) {
            return key
          }
        }
      }
    }
  },
  methods: {
    /**
     * This method useful to handle onClick event
     *
     * @event click
     * @type function
     */
    handleClick(event) {
      this.$emit('click', event)
    },
    /**
     * This method useful to handle onBlur event
     *
     * @event blur
     * @type function
     */
    handleBlur(event) {
      this.focused = false
      this.$emit('blur', event)
    },
    /**
     * This method useful to handle onFocus event
     *
     * @event focus
     * @type function
     */
    handleFocus(event) {
      this.focused = true
      this.$emit('focus', event)
    },
    handleInput(event) {
      this.$nextTick(() => {
        this.newValue = event.target.value
      })
    },
    /**
     * This method useful to handle onChange event
     *
     * @event change
     * @type function
     */
    handleChange(event) {
      this.$emit('change', event.target.value)
    },
    /**
     * This method useful to handle onKeyup event
     *
     * @event keyup
     * @type function
     */
    handleKeyUp(event) {
      this.$emit('keyup', event)
    },
    /**
     * This method useful to handle onKeydown event
     *
     * @event keydown
     * @type function
     */
    handleKeyDown(event) {
      this.$emit('keydown', event)
    },
    /**
     * This method useful to handle onKeydown.enter event
     *
     * @event enter
     * @type function
     */
    handleEnter(event) {
      this.$emit('enter', event)
    },
    /**
     * This method useful to handle onKeypress event
     *
     * @event keypress
     * @type function
     */
    handleKeyPress(event) {
      this.$emit('keypress', event)
    }
  }
}
